
<div>
	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"><h1>Experience</h1></v-list-item-title>
				<v-list-item-subtitle class="text-center text-wrap">Make your profile standout, tell us where you have worked.</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-container>
		<v-form ref="locumExperienceForm" v-model="valid" class="pa-4 pt-0">
			<v-card-text align="center" justify="center" class="justify-center text-center">
				<v-menu
					ref="experienceStartMenu"
					v-model="experienceStartMenu"
					offset-y
					:close-on-content-click="false"
					transition="scale-transition"
					max-width="320px"
					min-width="290px"
				>
					<template #activator="{ on }">
						<v-text-field
							v-model="dateFormatted"
							outlined
							class="pb-3"
							:label="getLabel('experienceStartDate', 'Select experience start date')"
							append-icon="event"
							hint="Select or type the date (DD/MM/YYYY)"
							persistent-hint
							:rules="experiencestartRules"
							@blur="setDate"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="experienceStartDate" :max="new Date().toISOString()" no-title @input="experienceStartMenu = false"></v-date-picker>
				</v-menu>
			</v-card-text>

			<v-card-text v-for="industry in workedAtOptions" :key="industry.label" align="center" justify="center" class="justify-center text-center pb-2 text-wrap">
				<v-row class="pb-2" align="center" justify="center"
					><strong>{{ workedAtLabel(industry.label) }} you've worked at</strong></v-row
				>
				<v-row dense>
					<v-col v-for="option in industry.options" :key="workedAtOptionKey(option)" cols="12" sm="6" md="4">
						<v-container>
							<v-checkbox
								v-model="companiesWorkedFor"
								multiple
								color="primary"
								:label="workedAtOptionLabel(option)"
								:value="workedAtOptionValue(option)"
								class="pa-0 ma-0"
							></v-checkbox>
						</v-container>
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-text v-if="industryItems">
				<div align="center" justify="center">
					<strong class="pb-2">{{ skillsSectionHeading }}</strong>
				</div>
				<div class="mt-4">
					<v-menu :close-on-content-click="false" max-height="350" min-width="250" top>
						<template #activator="{ on, attrs }">
							<v-chip outlined class="ma-1" v-bind="attrs" v-on="on">
								<v-icon left> mdi-plus </v-icon>
								Add Skills
							</v-chip>
						</template>
						<v-sheet>
							<v-treeview v-model="industryTree" selectable item-disabled="locked" :items="industryItems">
								<template v-if="!props.item.children || props.item.nodeActive" slot="prepend" slot-scope="props">
									<v-checkbox
										v-model="props.item.selected"
										:disabled="props.item.locked || props.item.nodeActive"
										:indeterminate="props.item.nodeActive"
										@change="treeChanged($event, props.item)"
									/>
								</template>
							</v-treeview>
						</v-sheet>
					</v-menu>
					<v-chip v-for="(skill, i) of selectedSkills" :key="i" class="ma-1" close close-icon="mdi-close" @click:close="removeSkill(skill.code)">{{
						skill.name
					}}</v-chip>
				</div>
			</v-card-text>
		</v-form>
	</v-container>
</div>
